// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#fc127f","button":"button__3C4dA","transparent":"transparent__2diGT","outlined":"outlined__t89I4","active":"active__1J6BC","fadeIn":"fadeIn__ZjCKG"};